import { Outlet, Navigate } from 'react-router-dom';

const PrivateRoute = () => {
  const isLoggedIn = localStorage.getItem('fullName') ? true : false;
  return isLoggedIn ? <Outlet /> : <Navigate to="/ingresar" />;
};

export default PrivateRoute;
